export function transformReceiptUrl(url: string | undefined) {
  if (!url) return url

  const btcWithdrawalReceiptMatch = /.+\/payments\/ST\$_BTCWDL_([^/]+)\/receipt/g
  if (btcWithdrawalReceiptMatch.test(url)) {
    return url.replace(btcWithdrawalReceiptMatch, '/receipt/btc_withdrawal/$1')
  }

  const btcDepositReceiptMatch = /.+(\/receipt\/btc_deposit.+)/
  if (btcDepositReceiptMatch.test(url)) {
    return url.replace(btcDepositReceiptMatch, '$1')
  }

  return url
}
